import { validateImgSlug } from '../img';

export interface IBuildWebVideoR2KeyArgs {
  slug: string;
}

// No version in the key: the web/OG "breakdown" video is the single canonical
// asset per challenge, so a re-render overwrites it in place (same folder as the
// vertical social video, distinguished by `-breakdown` so they never collide).
export function buildWebVideoR2Key(args: IBuildWebVideoR2KeyArgs): string {
  if (!validateImgSlug(args.slug)) {
    throw new Error(`Invalid slug for web video R2 key: ${args.slug}`);
  }
  return `share/${args.slug}/coolmate-${args.slug}-breakdown.mp4`;
}
